export default "__VITE_ASSET__B2QxFug7__"